<template>
  <div class="wrapper" v-if="!missing">
    <p v-if="hasDriver && driver.time">Водій буде за {{ driver.time }} хв.</p>
    <p v-else-if="hasDriver">
      Водій:
    </p>
    <h3 class="client-name" v-if="hasDriver">{{ driver.car_brand || driver.name }}</h3>
    <div class="info">
      <span class="searching" v-if="!hasDriver">Пошук машини... ({{search_minutes}} {{$t('waiting.time')}})</span>
      <span v-if="hasDriver">
        <img src="/icons/mobile-white.svg" />
      </span>
      <span class="float-right" v-if="hasDriver">
        <a class="driver-phone" :href="`tel:${driver.phone}`">{{
          driver.phone
        }}</a>
      </span>
    </div>
    <!-- <div class="info">
      <span>
        <img src="/icons/car.svg" /> {{ $t('delivery_driver.car') }}
      </span>
      <span class="float-right">{{ driver.car }}</span>
    </div>-->
  </div>
  <div class="wrapper" v-else-if="missing">
      <div class="no-driver">{{$t('delivery_driver.warning')}}</div>
      <a class="dispatcher-phone" :href="`tel:${missingDriverPhone}`">
          {{ missingDriverPhone }}
      </a>
    </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    driver: Object,
    missing: {
      type: Boolean,
      default: false
    },
    preorder: Object
  },
  data() {
    return {
      search_minutes: 60,
      search_interval: null
    }
  },
  methods: {
    tickSearchTime() {
      this.search_minutes = moment(this.preorder.accepted_at).add(15, 'minutes').diff(moment(), 'minutes');

      this.search_minutes = Math.max(0, this.search_minutes);
    }
  },
  computed: {
    hasDriver() {
      return this.driver && this.driver.phone;
    },
    missingDriverPhone() {
      return this.$store.state.delivery_settings.dispatcher_phone;
    }
  },
  mounted() {
    this.tickSearchTime();

    this.search_interval = setInterval(this.tickSearchTime, 30 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.search_interval);
  }
};
</script>

<style scoped>
.wrapper > * {
  padding: 0;
  margin: 0;
}

.wrapper {
  width: 90vw;
  margin: -7vh auto 0;
  padding: 9vh 0 1.2vh 0;
  background: #1d1d1b;
  color: #ededed;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px 16px 20px 16px;
}
.wrapper p {
  line-height: 0.8;
  padding: 0 5.4vw;
}
.client-name {
  margin-top: 2.3vh;
  width: 100%;
  background: #ededed;
  color: #1d1d1b;
  font-size: 6.7vw;
  padding: 1.3vh 5.4vw;
}

span.searching {
  color: #908f8d;
  font-size: 2vh;
}

.driver-phone {
  color: #ededed;
  text-decoration: underline;
}
h3 {
  font-weight: 500;
  line-height: 0.8;
}
.info {
  display: flex;
  justify-content: space-between;
  padding: 2.3vh 5.4vw 0;
}

.no-driver {
  color: #908f8d;
  font-size: 2vh;
  padding: 0 5.4vw;
}

.dispatcher-phone {
  color: #ededed;
  text-decoration: underline;
  padding: 0 5.4vw;
}

@media (min-width: 768px) {
  .wrapper {
    width: 23.264vw;
    padding-top: 3vw;
    border-radius: 0 0 1.389vw 1.389vw;
  }
  .wrapper p, .no-driver, .dispatcher-phone {
    padding: 1.181vw 1.389vw 0.694vw;
  }
  h3.client-name {
    padding: 0.556vw 1.389vw;
    font-size: 1.736vw;
    line-height: 85.69%;
    margin: 0;
  }
  div.info {
    padding: 1.181vw 1.389vw 0;
    margin-bottom: -0.694vw;
  }
  div.info .searching {
    font-size: 1.111vw;
  }
}
</style>
